import { Optional, Injectable } from '@angular/core';
import { MessagerService } from '@farris/ui-messager';
import { LanguageService } from '../languag.service';
import { ServerExceptionEntity, ExceptionLevel } from './types';
import {
  IExceptionStrategy, InfoExceptionStrategy, WarningExceptionStrategy, ErrorExceptionStrategy, FatalExceptionStrategy
} from './exception_strategy';


@Injectable()
export class ExceptionFactory {

  /**
   * å¼å¸¸å·¥åå®ä¾
   */
  private static exceptionFactory: ExceptionFactory = null;

  /**
   * æé å½æ°
   * @param messagerService æ¶æ¯æå¡
   * @param languageService å¤è¯­è¨æå¡
   */
  private constructor(
    public messagerService: MessagerService,
    @Optional() private languageService: LanguageService,
  ) {

  }

  /**
   * è·åå·¥åå®ä¾
   * @param messagerService æ¶æ¯æå¡
   * @param languageService å¤è¯­è¨æå¡
   */
  public static getInstance(messagerService: MessagerService, languageService: LanguageService): ExceptionFactory {
    if (!this.exceptionFactory) {
      this.exceptionFactory = new ExceptionFactory(messagerService, languageService);
    }

    return this.exceptionFactory;
  }

  /**
   * è·åå¼å¸¸å¤çç­ç¥
   * @param exceptionLevel å¼å¸¸ç­çº§
   */
  public getExceptionHandleStrategy(exceptionLevel: ExceptionLevel): IExceptionStrategy {
    let exceptionStrategy: IExceptionStrategy;

    switch (exceptionLevel) {
      case ExceptionLevel.Info:
        exceptionStrategy = new InfoExceptionStrategy(this.messagerService, this.languageService);
        break;
      case ExceptionLevel.Warning:
        exceptionStrategy = new WarningExceptionStrategy(this.messagerService, this.languageService);
        break;
      case ExceptionLevel.Error:
        exceptionStrategy = new ErrorExceptionStrategy(this.messagerService, this.languageService);
        break;
      case ExceptionLevel.Fatal:
        exceptionStrategy = new FatalExceptionStrategy(this.messagerService, this.languageService);
        break;
      default:

        // é»è®¤å¼å¸¸ç­çº§æ¯éè¯¯
        exceptionStrategy = new ErrorExceptionStrategy(this.messagerService, this.languageService);
        break;
    }

    return exceptionStrategy;
  }
}
